module.exports = __webpack_public_path__ + "static/img/wxxiaochengxuimg.b3fde0d9.jpg";